const $body = $('body')
const $html = $('html')
const $imageModal = $('#image-modal')
const $image = $('#image-modal-src')

$body.on('click', '.js-follow-mouse-open-image', function (e) {
  e.preventDefault()
  let src = $(this).data('image-src')

  openImageModal(src)

})

$body.on('click', '.modal-image-close', function (e){
  e.preventDefault()

  hideImageModal()
})

function hideImageModal() {
  $imageModal.removeClass('modal-active')
  $html.removeClass('modal-visible')
  $image.attr('src', '')

  //window.history.pushState(null, null, document.location)
}


function openImageModal(src) {

  $image.attr('src', src)

  setTimeout(function() {

    $imageModal.addClass('modal-active')
    $html.addClass('modal-visible')
  }, 5)

}
